export default function TubeIcon() {
  return (
    <svg
      width="12"
      height="16"
      viewBox="7 2 10 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 2C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3C17 3.26522 16.8946 3.51957 16.7071 3.70711C16.5196 3.89464 16.2652 4 16 4V18C16 19.0609 15.5786 20.0783 14.8284 20.8284C14.0783 21.5786 13.0609 22 12 22C10.9391 22 9.92172 21.5786 9.17157 20.8284C8.42143 20.0783 8 19.0609 8 18V4C7.73478 4 7.48043 3.89464 7.29289 3.70711C7.10536 3.51957 7 3.26522 7 3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16ZM14 4H10V11H14V4Z"
        fill="currentColor"
      />
    </svg>
  );
}
